import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class PaymentImportModel extends Model {
  static reducer(action, PaymentImportModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.PaymentImport.schema:
        action.payload.forEach((payload) => {
          const dbData = PaymentImportModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          PaymentImportModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
PaymentImportModel.modelName = "PaymentImportModel";

PaymentImportModel.fields = {
  id: attr(),
};

export default PaymentImportModel;